import { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import { clone } from '../../../core/utils';
import { formatDate, formatGender } from '../../../components/renderers';
import { create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';

const s:any ={
  reqform: {
    //
  },
};

class PersonalPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: false,
      count:0
    };
  }

  componentDidMount(){
    this.props.setValid(this.state.valid);
  }

  formconfig = () => {
    const config = {
      service: {
        name: 'personal',
        title: 'Personal Information',
        eform: [
          {id:'fnm',label:'Firstname',type:'tf',req:1,ops:{}},
          {id:'mnm',label:'Middlename',type:'tf',req:0,ops:{}},
          {id:'lnm',label:'Lastname',type:'ta',req:1,ops:{}},
          {id:'mbn',label:'Mobile',type:'tf',req:1,ops:{type:'tel'}},
          {id:'dob',label:'Date of Birth',type:'df',req:1,ops:{}},
          {id:'gdi',label:'Gender',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'gender'}},
        ],
      },
      create: true,
      actions: { add: 'Add' },
      panels: { add: 'simple' },
    };
    return config;
  }

  setValid = (data:any)  => {
    const config = this.formconfig();
    const valid = isValid(config,data);
    console.log('valid:',valid);
    this.props.setValid(valid);
  }

  onChange = (name:any) => (value:any) => {
    console.log('wizform.onChange:',name, value,this.props.data);
    const {data} = this.props;
    const newdata = {...data.data,[name]:value};
    this.setValid(newdata);
    this.props.setItem('data','data',newdata);
  }

  makeform = () => {
    const config = this.formconfig();
    const { record, classes, extras } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = {dob:formatDate, gdi:formatGender};
    const onChange = this.onChange.bind(this);
    const form = create(mode,sdata,record,formatters,onChange,classes,extras);
    return form;
  }

  render() {
    return this.makeform();
  }
}

PersonalPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default PersonalPanel;
